(function () {
  if (window.BYFARVolume2) return;
  window.BYFARVolume2 = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting && !reduce.matches) {
        if (!video.src) video.src = video.dataset.src;
        video.play().catch(function () {});
      } else if (!entry.isIntersecting) {
        video.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.01 });
  function init() {
    document.querySelectorAll('.vol2-layout video:not([data-vol2-bound])').forEach(function (video) {
      video.dataset.vol2Bound = 'true';
      observer.observe(video);
    });
  }
  reduce.addEventListener('change', function () {
    if (reduce.matches) document.querySelectorAll('.vol2-layout video').forEach(function (v) { v.pause(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
